import React from "react";
import PropTypes from "prop-types";
// Chakra imports
import { Box, Flex } from "@chakra-ui/react";

function AuthCover(props) {
  const { children, image, ...rest } = props;
  return (
    <Flex position='relative'>
      <Flex
        minH={{ md: "600px" }}
        h="100vh"
        w='100%'
        maxW='1044px'
        mx='auto'
        justifyContent='space-between'>
        {children}
        <Box
          overflowX='hidden'
          h={{ base: "100%", lg: "100%" }}
          w='100%'
          left='0px'
          position='absolute'
          bgSize="cover"
          bgPosition="center"
          minH="100vh"
          bgImage={image}>
          <Box
            w='100%'
            h='100%'
            bgSize='cover'
            bg="rgba(0, 0, 0, 0.6)"
            backdropFilter="blur(5px)"></Box>
        </Box>
      </Flex>
    </Flex>
  );
}
// PROPS

AuthCover.propTypes = {
  image: PropTypes.any,
};
export default AuthCover;
